<template>
  <div id="main-content">
    <a-form
      layout="inline"
      style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;"
    >
      <a-form-item style="color: red;">
        唯一时区
      </a-form-item>
      <a-form-item>
        <a-select
          v-model="account"
          style="width: 200px"
          allowClear
          placeholder="请选择账户"
          @change="change_filter"
        >
          <a-select-option
            :value="account"
            :key="account"
            v-for="account in account_list"
            >{{ account }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" @click="downLoad">导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-button
          type="danger"
          ghost
          @click="
            () => {
              changeRatioShow = true;
            }
          "
          style="margin-right: 10px;"
          >系数修正</a-button
        >
        <a-range-picker
          v-model="date"
          valueFormat="YYYY-MM-DD"
          style="width: 240px;"
          @change="change_filter"
        />
      </a-form-item>
    </a-form>
    <a-table
      :columns="getTableColumns"
      id="show-table"
      style="flex: 1;overflow-y: hidden;background: #ffffff"
      :scroll="{
        x: '500px',
        y: _get_table_scroll({ id: 'show-table', extraHeight: extraHeight })
      }"
      :rowKey="item => item.date"
      :loading="tableLoad"
      :data-source="tableData"
      bordered
      :pagination="false"
    >
    </a-table>
    <RatioDialog
      :show-dialog="changeRatioShow"
      :is-ios="1"
      @close-dialog="
        () => {
          changeRatioShow = false;
        }
      "
    ></RatioDialog>
    <DataErrorDialog
      :show-dialog="changeDataShow"
      :base-info="changeDataInfo"
      @close-dialog="
        () => {
          changeDataShow = false;
          init_data();
        }
      "
    ></DataErrorDialog>
  </div>
</template>

<script>
import { GetPurchaseCheckPlatform } from "../../../api/v1/purchase_api";
import RatioDialog from "../../../components/Business/Dialog/RatioDialog";
import DataErrorDialog from "../../../components/Business/Dialog/DataErrorDialog";

export default {
  name: "Ios",
  components: { DataErrorDialog, RatioDialog },
  data() {
    return {
      account: undefined,
      date: ["", ""],
      tableLoad: false,
      tableData: [],
      fields: [],
      account_list: [],
      extraHeight: 64,
      changeRatioShow: false,
      changeDataInfo: {},
      changeDataShow: false
    };
  },
  computed: {
    getTableColumns() {
      let _table_columns = [
        {
          title: "日期",
          fixed: "left",
          width: 200,
          scopedSlots: { customRender: "date" },
          dataIndex: "date",
          align: "center"
        }
      ];
      this.fields.forEach(item => {
        let _table_column_item = {
          title:
            item["account"] +
            "--" +
            this.$store.state.purchaseAccount[item["account"]],
          y_show: false,
          y_times: Object.keys(item.children).length,
          align: "center",
          children: []
        };
        if (!this.account_list.includes(item["account"])) {
          this.account_list.push(item["account"]);
        }
        Object.keys(item.children).forEach(item_key => {
          _table_column_item.children.push({
            key: item["account"] + "--" + item_key,
            title: item.children[item_key],
            align: "center",
            dataIndex: item_key,
            width: item.children[item_key].length * 10,
            customRender: (t, row, index) => {
              let text =
                (row[item["account"]] && row[item["account"]][item_key]) || "";

              if (index === this.tableData.length - 1) {
                if (!_table_column_item.y_show) {
                  _table_column_item.y_show = true;
                  let _this = this;
                  return {
                    children: _this.$createElement("a", {
                      domProps: {
                        innerHTML: row[item["account"]]
                      },
                      on: {
                        click: function() {
                          _this.changeData(
                            row[item["account"]],
                            "账户-" + item["account"]
                          );
                          // _this.customHandleDetail(r)
                        }
                      }
                    }),
                    attrs: {
                      colSpan: _table_column_item.y_times
                    }
                  };
                } else {
                  return {
                    attrs: {
                      colSpan: 0
                    }
                  };
                }
              } else {
                if (row["date"] != "应用汇总") {
                  return text;
                }

                let _this = this;
                return _this.$createElement("a", {
                  domProps: {
                    innerHTML: text
                  },
                  on: {
                    click: function() {
                      _this.changeData(text, item.children[item_key]);
                    }
                  }
                });
              }
            }
          });
        });
        _table_columns.push(_table_column_item);
      });

      return _table_columns;
    }
  },
  mounted() {
    this.init_data();
  },
  methods: {
    changeData(num, channel) {
      this.changeDataInfo = {
        now_num: num,
        channel: channel,
        type: "purchase",
        start: this.date[0],
        end: this.date[1],
        change_num: 0
      };
      this.changeDataShow = true;
      this.extraHeight = 10;
    },
    change_filter() {
      this.extraHeight = 10;
      this.init_data();
    },
    init_data() {
      this.tableLoad = true;
      GetPurchaseCheckPlatform({
        platform: "ios",
        start: this.date[0],
        end: this.date[1],
        account: this.account
      }).then(resp => {
        this.tableLoad = false;
        if (resp.code === 200) {
          this.date = resp.data.date;
          this.tableData = resp.data.list;
          this.fields = resp.data.fields;
        }
      });
    },
    downLoad(){
      let name = "IOS细分"
      name += this.date[0]+"至"+this.date[1]+"的"
      let columns = []
      this.getTableColumns.forEach(item=>{
        if (item.children){
          item.children.forEach(child=>{
            columns.push({
              title: item.title+"--"+child.title,
              dataIndex: child.key,
              width: 150,
              align:'center'
            })
          })
        } else {
          columns.push({
            title: item.title,
            dataIndex: item.dataIndex,
            width: 150,
            align:'center'
          })
        }
      })

      let _table_data = []
      this.tableData.forEach((item, index)=>{
        if(index == this.tableData.length-1) return
        const flattenedItem = {
          date: item.date
        }
        for (const key in item) {
          if (key !== 'date' && typeof item[key] === 'object' && item[key] !== null) {
            for (const subKey in item[key]) {
              flattenedItem[`${key}--${subKey}`] = item[key][subKey]
            }
          }
        }
        _table_data.push(flattenedItem)
      })
      this._export_cvs(_table_data,columns,name)
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Purchase/Check/Ios.vue